/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import Tooltip from '@material-ui/core/Tooltip';
import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Button from '../common/Button';

const useStyles = makeStyles(theme => ({
  tooltip: {
    fontSize: '0.9em',
  },
  container: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-end',
    },
  },
  button: {
    flexGrow: 1,
    '&:not(:first-child)': {
      marginLeft: '1.5rem',
    },
    '& button': {
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      flexGrow: 'initial',
    },
  },
}));

export default function SubmissionPreviewActions({ className, buttonsConfig }) {
  const classes = useStyles();

  const component = buttonsConfig?.map(({ text, tooltipText, icon, color, isButtonEnabled, onClick }) => {
    const buttonStyle = color === 'primary' ? 'primary' : 'inverted';
    return (
      <div key={text} className={classes.button}>
        <Tooltip classes={{ tooltip: classes.tooltip }} title={tooltipText} disableHoverListener={isButtonEnabled}>
          <span>
            <Button disabled={!isButtonEnabled} color={buttonStyle} startIcon={icon} onClick={onClick}>
              {text}
            </Button>
          </span>
        </Tooltip>
      </div>
    );
  });

  return useMemo(() => <div className={clsx(classes.container, className)}>{component}</div> ?? null, [buttonsConfig]);
}
